import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetRunFlowTaskOutputStepsParams {
  readonly id: string;
  readonly runAllOutputs: boolean;
  readonly flowOutputStepIds: string[];
}

export class SetRunFlowTaskOutputStepsRequest extends Request<SetRunFlowTaskOutputStepsParams, IResult> {
  constructor(params: SetRunFlowTaskOutputStepsParams) {
    super('setRunFlowTaskOutputSteps', params);
  }
}
